export default __webpack_public_path__ + "static/media/0bc17b834ab6624b716e55b45fa2ac77.1f9050d2.jpeg";